
<div v-if="site" class="lm-border pa-3">
    <f-title :title="'Vertragskonditionen Wartungskosten' + (showUnit ? ' (' + this.site.fabricNo + ')': '')"  />
    <v-row class="no-frame mt-0 pt-1 pb-1">
        <v-col class="no-frame pr-2">
            <f-read-only-field
                label        = "Wartungskosten pro Jahr"
                :value       = "contract.unit ? toMoney(contract.unit.costs) : '---'"
                filled
                align-right
            />
        </v-col>
        <v-col class="no-frame pl-2 white">
            <f-read-only-field
                label  = "Wartungen pro Jahr"
                :value = "contract.unit ? contract.unit.count : '---'"
                filled
                align-right
            />
        </v-col>
    </v-row>
    <v-row class="no-frame mt-0 mb-2" >
        <v-col class="no-frame pr-2">
            <f-read-only-field
                label        = "Rechnungsbetrag"
                :value       = "amount"
                filled
                align-right
            />
        </v-col>
        <v-col class="no-frame pl-2 pb-2">
            <f-read-only-field
                label  = "Rechnungen pro Jahr am"
                :value = "contract.invoicesPerYear"
                filled
                align-right
            />
        </v-col>
    </v-row>
</div>
